import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useDispatch, useSelector} from 'react-redux';
import { SET_DRAWER } from '../redux/actions/types';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import mineLogo from '../assets/mining.svg';
import mineLogoSelected from '../assets/logo2.svg'
import Avatar from '@mui/material/Avatar';
import EqualizerRoundedIcon from '@mui/icons-material/EqualizerRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import CollectionsRoundedIcon from '@mui/icons-material/CollectionsRounded';
import { Link, useLocation  } from 'react-router-dom';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import SwapVertIcon from '@mui/icons-material/SwapVert';


export default function Footer() {

  const application = useSelector(state => ({
    ...state.application
  }));
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch();
  const location = useLocation()



  const toggleDrawer = () => {
    dispatch({
      type: SET_DRAWER,
      payload: { isDrawerOpen: !application.isDrawerOpen}
    });
  }

  const homePageUrl = '/home';
  const dashBoardUrl = ['dashboard', 'deposit-statement', 'rewards-statement', 'withdrawal-statement'];
  const userUrl = ['users'];
  
  React.useEffect(() => {
    if (homePageUrl.includes(location.pathname)){
      setValue(0);
    }
    else if (dashBoardUrl.includes(location.pathname.replace('/', ''))){
      setValue(1);
    }
    else if (userUrl.includes(location.pathname.replace('/', '')) || location.pathname.replace('/', '').match('teamoverview') || location.pathname.replace('/', '').match('teaminfo')){
      setValue(2);
    }
    else if (userUrl.includes(location.pathname.replace('/', '')) || location.pathname.replace('/', '').match('swap') || location.pathname.replace('/', '').match('swap')){
      setValue(3);
    }

  }, []);
      

  return (
    <Paper className="footer" sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000000 }} elevation={3}>
    <BottomNavigation
      showLabels
      style={{backgroundColor: 'transparent'}} 
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
    >
   
      <BottomNavigationAction component={Link} to="/home" style={{opacity: value === 0 ? '1' : '0.5'}} icon={
              <Avatar style={{background: 'transparent'}} sx={{ width: 40, height: 40 }}>
                      {value == 0 && <img style={{width: 40}} src={mineLogoSelected} alt="mine"/> }
                      {value != 0 && <img style={{width: 40}} src={mineLogoSelected} alt="mine"/>}                    
              </Avatar>} />
 
      <BottomNavigationAction component={Link} to="/dashboard" style={{opacity: value === 1 ? '1' : '0.5'}} icon={<EqualizerRoundedIcon/>} />
      <BottomNavigationAction component={Link} to="/users" style={{opacity: value === 2 ? '1' : '0.5'}} icon={<PeopleRoundedIcon/>} />
      <BottomNavigationAction component={Link} to="/swap"  style={{opacity: value === 3 ? '1' : '0.5'}} icon={<SwapVertIcon/>} />
    </BottomNavigation>
  </Paper>
  );
}
